import { ownerPermissions } from "./owner.js";
import { adminPermissions } from "./admin.js";
import { memberPermissions } from "./member.js";

const appPermissions = [ownerPermissions, adminPermissions, memberPermissions];

export { appPermissions };
